export enum BookingNotifyType {
  Issue = 1,
  Reload = 2,
  Prefetch = 3,
}
